@let hasSidenav = hasSidebar$ | async;
<mat-toolbar class="Topbar" [class.Topbar--hijacking]="hijacker$ | async">
  <div class="flex items-center gap-2">
    @if (isMobile()) {
      <img class="Topbar__logo" src="/assets/images/ab_logo--color.png" />
    }
    @if (isMobile() && hasSidenav) {
      <button mat-icon-button type="button" (click)="toggleSideNav()">
        <mat-icon>menu</mat-icon>
      </button>
    }

    <ng-container *awIsGod>
      @if (api.apiEnv$ | async; as env) {
        <button
          mat-icon-button
          type="button"
          [matBadge]="env.name | shorten: 1 | ucfirst"
          [matMenuTriggerFor]="apiEnvMenu"
          [matMenuTriggerData]="{ envs: availableEnvs$ | async, activeEnv: env }"
          [matTooltip]="env.name + ': ' + env.url"
        >
          <mat-icon>api</mat-icon>
        </button>
      }
    </ng-container>
    @if (hijacker$ | async; as hijackState) {
      <div class="Topbar__pilot flex items-center justify-start">
        <mat-icon>fingerprint</mat-icon>
        Pilot: {{ hijackState.client.name }}
        <button matTooltip="Avbryt pilotläge" type="button" mat-icon-button (click)="cancelHijack()">
          <mat-icon>cancel</mat-icon>
        </button>
      </div>
    }
  </div>
  <app-topbar-unit-tree class="flex flex-col flex-1 overflow-hidden" (selectUnit)="setActiveUnit($event)"></app-topbar-unit-tree>
  <div class="flex items-center flex-none gap-2">
    @for (feature of topbarFeatures$ | async; track feature.action) {
      @let badgeValue = feature.badge?.source && feature.badge?.enabled ? (feature.badge.source | async) : null;
      <button
        class="Topbar__button !hidden md:!inline-flex"
        type="button"
        *awIsGranted="feature.requiredPermissions"
        mat-icon-button
        [matBadge]="badgeValue"
        [matBadgeHidden]="!badgeValue"
        [matTooltip]="feature.title | translate"
        (click)="featureClicked(feature, $event)"
      >
        <mat-icon>{{ feature.icon }}</mat-icon>
      </button>
    }

    @if (hasApiLanguageEnabled$ | async) {
      <button class="Topbar__button !hidden md:!inline-flex" type="button" mat-button [matMenuTriggerFor]="apiLanguageMenu">
        <div class="flex items-center gap-2">
          <mat-icon>translate</mat-icon>
          {{ languageService.getCurrentApiLanguage() }}
          <mat-icon>arrow_drop_down</mat-icon>
        </div>
      </button>
    }

    <button mat-icon-button [matMenuTriggerFor]="attendoHelpMenu">
      <mat-icon>help_outline</mat-icon>
    </button>

    <mat-menu #attendoHelpMenu>
      <ng-template matMenuContent>
        <a mat-menu-item href="https://attendo.centuri.se/RegNo/%C3%961032" target="_blank">
          <span>Frågor och svar</span>
        </a>
        <a mat-menu-item href="https://attendo.centuri.se/RegNo/M0454" target="_blank">
          <span>Manual panelen</span>
        </a>
        <a mat-menu-item href="https://attendo.centuri.se/RegNo/%C3%961598" target="_blank">
          <span>Samtyckesblankett</span>
        </a>
        <a mat-menu-item href="https://attendo.centuri.se/RegNo/L0056" target="_blank">
          <span>Kort lathund</span>
        </a>
        <a mat-menu-item href="https://attendo.centuri.se/RegNo/M0692" target="_blank">
          <span>Manual appen</span>
        </a>
        <a mat-menu-item href="https://attendo.centuri.se/RegNo/%C3%960758" target="_blank">
          <span>Principer fotografering</span>
        </a>
        <a mat-menu-item href="https://attendo.centuri.se/RegNo/L0050" target="_blank">
          <span>Instruktion</span>
        </a>
      </ng-template>
    </mat-menu>

    @if (activeUnit$ | async; as unit) {
      @let mergedBadgeSourcesForHiddenFeatures = mergedBadgeSourcesForHiddenFeatures$ | async;
      <button
        class="Topbar__button"
        mat-button
        type="button"
        [matMenuTriggerFor]="menu"
        [matMenuTriggerData]="{ unit: unit }"
        [matBadge]="mergedBadgeSourcesForHiddenFeatures"
        [matBadgeHidden]="mergedBadgeSourcesForHiddenFeatures <= 0"
        matBadgePosition="above before"
      >
        <div class="flex gap-2 items-center">
          <app-client-avatar [client]="client$ | async" class="w-8 h-8"></app-client-avatar>
          @if (!isMobile()) {
            <span>{{ (client$ | async).given_name }}</span>
          }
          <!-- <div class="Topbar__button__badge" [hidden]="!badge || (hasSidebar$ | async)"></div> -->
          <mat-icon>arrow_drop_down</mat-icon>
        </div>
      </button>
    }
  </div>
  @let units = units$ | async;
  <mat-menu class="Topbar__menu" #menu="matMenu" xPosition="before" yPosition="below" class="auto-width">
    <ng-template matMenuContent let-unit="unit">
      @if (units.length > 1) {
        <button mat-menu-item type="button" [matMenuTriggerFor]="unitMenu" [matMenuTriggerData]="{ unit: unit }" (click)="goToUnit(unit)">
          <mat-icon>home</mat-icon>
          {{ unit.title }}
        </button>
      }
      @if (hasPanelLanguageEnabled$ | async) {
        <mat-divider></mat-divider>
        <button mat-menu-item type="button" [matMenuTriggerFor]="languageMenu">
          <mat-icon>language</mat-icon>
          {{ 'LANGUAGES.LANGUAGE' | translate }}
        </button>
      }
      @if (hasApiLanguageEnabled$ | async) {
        <mat-divider></mat-divider>
        <button mat-menu-item type="button" [matMenuTriggerFor]="apiLanguageMenu">
          <mat-icon>translate</mat-icon>
          <span>API-{{ 'LANGUAGES.LANGUAGE' | translate }}: {{ languageService.getCurrentApiLanguage() }}</span>
        </button>
      }
      <mat-divider></mat-divider>
      @for (feature of applicableFeatures$ | async; track feature.action) {
        @let badgeValue = feature.badge?.source && feature.badge?.enabled ? (feature.badge.source | async) : null;
        <button mat-menu-item type="button" *awIsGranted="feature.requiredPermissions" (click)="featureClicked(feature, $event)">
          <div class="flex items-center justify-between w-full gap-4">
            <div class="flex items-center">
              <mat-icon>{{ feature.icon }}</mat-icon>
              <span>{{ feature.title | translate }}</span>
              @if (badgeValue) {
                <span class="px-2 py-0.5 bg-primary rounded-full text-xs text-on-primary">{{ badgeValue }}</span>
              }
            </div>
            <button mat-icon-button type="button" class="!w-8 !h-8" (click)="togglePinnedFeature(feature); $event.stopPropagation()">
              <mat-icon class="!w-6 !h-6 !text-[24px] !mr-0" [svgIcon]="feature.pinned ? 'keep-pin-filled' : 'keep-pin'"></mat-icon>
            </button>
          </div>
        </button>
      }
      <mat-divider></mat-divider>
      <button mat-menu-item type="button" (click)="goToSettings()">
        <mat-icon>settings</mat-icon>
        {{ 'COMMON.SETTINGS' | translate }}
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item type="button" (click)="signout()"><mat-icon>lock</mat-icon> {{ 'COMMON.LOGOUT' | translate }}</button>
    </ng-template>
  </mat-menu>

  <mat-menu #unitMenu="matMenu" xPosition="before">
    <ng-template matMenuContent let-unit="unit">
      @for (obj of units | orderBy: 'title'; track obj) {
        <button mat-menu-item type="button" (click)="setActiveUnit(obj)" [disabled]="obj.uuid === unit.uuid">
          <div class="flex flex-col">
            @if (obj.attr('parents', 'json'); as parents) {
              <p class="Org-list__item__path">
                @for (parent of $any(parents); track parent) {
                  <span>{{ parent.title }}</span>
                }
              </p>
            }
            <p class="Org-list__item__title">{{ obj.title }}</p>
          </div>
        </button>
      }
    </ng-template>
  </mat-menu>

  <mat-menu #languageMenu="matMenu" xPosition="before">
    @for (obj of languageService.languages | orderBy: 'title'; track obj) {
      <button mat-menu-item type="button" (click)="setLanguage(obj)" [disabled]="obj.code === languageService.activeLanguage">
        <div class="flex flex-col">
          <p class="Org-list__item__title">{{ obj.title | translate }}</p>
        </div>
      </button>
    }
  </mat-menu>
</mat-toolbar>

<mat-menu #apiLanguageMenu="matMenu" xPosition="before" yPosition="below">
  @for (obj of languageService.apiLanguages | orderBy: 'title'; track obj) {
    <button
      mat-menu-item
      type="button"
      mat-menu-item
      (click)="setApiLanguage(obj)"
      [disabled]="obj.code === languageService.activeApiLanguage"
    >
      {{ obj.title | translate }}
    </button>
  }
</mat-menu>

<mat-menu #apiEnvMenu="matMenu" xPosition="before">
  <ng-template matMenuContent let-envs="envs" let-activeEnv="activeEnv">
    @for (env of envs; track env) {
      <button mat-menu-item type="button" (click)="setApiEnv(env)" [disabled]="env.name === activeEnv.name">
        {{ env.name }}
      </button>
    }
    <mat-divider></mat-divider>
    <button mat-menu-item type="button" (click)="setApiEnv(null)">Sätt default</button>
  </ng-template>
</mat-menu>
